module.exports = __webpack_public_path__ + "static/img/icon2-1.b68006ec.svg";